import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [commercial, setCommercial] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is already logged in
    const token = localStorage.getItem('token');
    const commercialData = localStorage.getItem('commercialData');
    const storedRole = localStorage.getItem('userRole');
    
    if (token && commercialData) {
      setIsAuthenticated(true);
      setCommercial(JSON.parse(commercialData));
      setUserRole(storedRole);
    }
    setLoading(false);
  }, []);

  const login = (commercialData) => {
    localStorage.setItem('token', commercialData.token);
    localStorage.setItem('commercialData', JSON.stringify(commercialData));
    localStorage.setItem('userRole', commercialData.type);
    setIsAuthenticated(true);
    setCommercial(commercialData);
    setUserRole(commercialData.type);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('commercialData');
    localStorage.removeItem('userRole');
    setIsAuthenticated(false);
    setCommercial(null);
    setUserRole(null);
  };

  const value = {
    isAuthenticated,
    commercial,
    userRole,
    login,
    logout,
    loading,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}; 